import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPublicVideo } from "../api";

/** Posts a clip to the public feed and refreshes the feed on success. */
export function useCreatePublicVideo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPublicVideo,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["public-videos"] });
    },
  });
}
